﻿import {ProjetEditor} from "./ProjetEditor.js";
import {TemplateListItem} from "../Template/TemplateListItem.js";
import {OtpListItem} from "../Otp/OtpListItem.js";
import {RessourceSlot} from "../../Tools/Disposable/RessourceSlot";
import {DisposableStack} from "../../Tools/Disposable/DisposableStack";
import {Projet} from "../../Controller/Projet/ProjetRead";

export class ProjetTab {
    #jqContainer: JQuery | undefined;
    #jqMainContainer: JQuery | undefined;
    #jqTabContainer: JQuery | undefined;
    #jqTitre: JQuery | undefined;
    #kTab: kendo.ui.TabStrip | undefined;
    #projetId: string | undefined;
    #titre: string | undefined;
    readonly #componentStack = new DisposableStack();
    readonly #slotProjetEditor = new RessourceSlot<ProjetEditor>();
    readonly #SlotTemplateListItem = new RessourceSlot<TemplateListItem>();
    readonly #SlotOtpListItem = new RessourceSlot<OtpListItem>();

    constructor(option: IProjetTabOption) {
        this.#jqMainContainer = option.jqMainContainer;
        this.#projetId = option.projetId;

        this.#componentStack.Use(this.#SlotTemplateListItem);
        this.#componentStack.Use(this.#slotProjetEditor);
        this.#componentStack.Use(this.#SlotOtpListItem);
    }

    public Init = async () => {
        this.#jqMainContainer.empty();
        await this.#buildHtml();
        await this.#buildTab();
        this.#kTab.select(0);
    }
    
    public get Titre(): string | undefined {
        return this.#titre; 
    }
    
    public set Titre(value: string | undefined) {
        this.#titre = value;
        if (this.#jqTitre) {
            this.#jqTitre.text(this.#titre);
        }
    }

    #buildHtml = async () => {
        this.#jqContainer = $("<div></div>")
            .css({
                height: "100%",
                width: "100%",
                margin: 0, padding: 0,
                display: "flex",
                flexDirection: "column"
            })
            .attr("circ-id", "projet-tab-container")
            .appendTo(this.#jqMainContainer)

        this.#jqTitre = $("<h2>Projet</h2>")
            .css({marginLeft: "10px", padding: 0})
            .appendTo(this.#jqContainer);
        
        this.#jqTabContainer = $("<div></div>")
            .css({display: "flex", flexGrow: "1"})
            .appendTo(this.#jqContainer);

        const ul = $("<ul></ul>")
            .appendTo(this.#jqTabContainer)

        ul.append("<li circ-action='generalite'>Généralités</li>");
        ul.append("<li circ-action='template'>Templates</li>");
        ul.append("<li circ-action='otp'>OTP</li>");

        this.#jqTabContainer.append("<div circ-id='generalite'></div>");
        this.#jqTabContainer.append("<div circ-id='template'></div>");
        this.#jqTabContainer.append("<div circ-id='otp'></div>");
    }

    #buildTab = async () => {

        this.#kTab = this.#jqTabContainer.kendoTabStrip({
            animation: false,
            select: (e: kendo.ui.TabStripSelectEvent) => {
                switch ($(e.item).attr("circ-action")) {
                    case "generalite":
                       this.#loadProjet().then(x => {
                           this.#slotProjetEditor.Reset(() => new ProjetEditor({
                               jqMainContainer: this.#jqTabContainer.find("[circ-id='generalite']"),
                               model: x
                           })).Init();
                       })
                        break;
                    case "template":
                        this.#SlotTemplateListItem.Reset(() => new TemplateListItem({
                            jqMainContainer: this.#jqTabContainer.find("[circ-id='template']"),
                            projetId: this.#projetId,
                        })).Init();
                        break;
                    case "otp":
                        this.#SlotOtpListItem.Reset(() => new OtpListItem({
                            jqMainContainer: this.#jqTabContainer.find("[circ-id='otp']"),
                            projetId: this.#projetId,
                        })).Init();
                        break;
                }
            }
        }).data("kendoTabStrip");
    }

    #loadProjet = async () => {
        
        // Todo: DirtyTracker à déclarer ici ?
        return Projet.Read({
            AsNoTracking: true,
            Primarykey: this.#projetId
        }).then(x => {
            this.Titre = x[0].Nom;
            return x[0];
        });
    }
    
    public Dispose(){
        this.#componentStack.Dispose();
    }
}

export interface IProjetTabOption {
    Titre?: string;
    jqMainContainer: JQuery;
    projetId: string;
}
